import { useState, useEffect } from 'react';
import { Button } from './ui/button';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem('cookieConsent', 'all');
    setIsVisible(false);
  };

  const acceptEssential = () => {
    localStorage.setItem('cookieConsent', 'essential');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white dark:bg-gray-800 p-4 shadow-lg z-50 border-t border-gray-200 dark:border-gray-700">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="text-sm text-gray-600 dark:text-gray-300">
          <p>
            Мы используем файлы cookie для улучшения вашего опыта на нашем сайте. 
            Вы можете выбрать, какие типы файлов cookie вы хотите разрешить.
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-2">
          <Button
            variant="outline"
            onClick={acceptEssential}
            className="whitespace-nowrap"
          >
            Только необходимые
          </Button>
          <Button
            onClick={acceptAll}
            className="whitespace-nowrap"
          >
            Принять все
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent; 